import { Component, OnInit, Input, ElementRef } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { PortalGlobals } from '../../../../portalglobals';
import { CurrentUser } from '../../../../common/models/current-user';
import { MfaGateway } from '../../../gateways/mfa-gateway';
import { authenticateModel } from '../../../../common/models/authenticateModel';
import { AuthTokenModel } from '../../../../auth/auth-token-model';
import { verifyAuthTokenModel } from '../../../../auth/verify-Auth-Token';
import { CustomError } from '../../../models/custom-error';
import { CurrentUserGateway } from '../../../../common/gateways/current-user-gateway';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common'

declare var window: any;
@Component({
    selector: 'app-send-authcode',
    standalone:true,
    imports: [FormsModule, CommonModule],
    templateUrl: './send-authcode.component.html',
    template: `<input [(ngModel)]="authModel" name="authModel">{{authModel}}`,
    styleUrl: './send-authcode.component.scss'
})
export class SendAuthcodeComponent implements OnInit {
    authModel: authenticateModel = new authenticateModel();
    userProfileID: number
    insCo: string
    errors: string 
    currentUser: CurrentUser
    showEmailNotSendError: boolean
    hideTokenValidity: boolean = true;
    tokenValidity: number;
    validityText = '';
    interval; 
    isAuthCodeEmpty: boolean = false;
    authcodeServer: string
    codeValidTill: string
    getCurrentURL:string
    defaultUrl: string
    isNeje: boolean = false;
    invalidTokenError: boolean = false;
    loading: boolean = false;
    mfaRequestModel: verifyAuthTokenModel;
    authTokenModel: AuthTokenModel = new AuthTokenModel();
    mode: any;
    constructor(private elementRef: ElementRef, private mfaGateWay: MfaGateway, private router: Router, private _currentUserGateway: CurrentUserGateway,public _global: PortalGlobals, private route: ActivatedRoute) {
        this.mfaRequestModel = {} as verifyAuthTokenModel
    }


    ngOnInit(): void {
        localStorage.setItem("isMfaValidated", "false");
        this.getCurrentURL = this.router.url.toLowerCase();
        if (this.getCurrentURL.includes('neje')) {
            this.isNeje=true;
        }
       const m = this.mode
       this.showEmailNotSendError = false;
       this.sendAuthenticationCode();
       this.setTokenTime();
       this.startTimer();
    }
    public sendAuthenticationCode() { 
        this.mfaGateWay.sendAuthCode().subscribe(
            (model: any) => {
                this.loading = true
                if (model !== undefined && model !== null) {
                    if ("isSent" in model) {
                        const valSent = model["isSent"];
                        if (valSent == "True") {
                            this.showEmailNotSendError = false;
                            this.hideTokenValidity = false;
                            clearInterval(this.interval);
                            this.setTokenTime();
                            this.startTimer();
                            this.loading = false
                           
                           
                        }
                        else {
                            this.showEmailNotSendError = true;
                            this.hideTokenValidity = true;
                            this.loading = false
                            

                        }
                    } 
                    if ("MFAAuthCodeServer" in model) {
                        const valMFACode = model["MFAAuthCodeServer"];
                        this.authcodeServer = valMFACode.toString();
                        this.loading = false
                        
                    }
                    if ("codeValidTill" in model) {
                        const valValdity = model["codeValidTill"];
                        this.codeValidTill = valValdity.toString();
                        this.loading = false
                        
                    }
                }
            })
        
    }
    authenticateCode() {
        this.invalidTokenError = false;
        this.isAuthCodeEmpty = false;
       
        if (this.checkUndefinedEmpty(this.authModel.AuthToken1) && this.checkUndefinedEmpty(this.authModel.AuthToken2) && this.checkUndefinedEmpty(this.authModel.AuthToken3) && this.checkUndefinedEmpty(this.authModel.AuthToken4) && this.checkUndefinedEmpty(this.authModel.AuthToken5) && this.checkUndefinedEmpty(this.authModel.AuthToken6)) {
            
            this.isAuthCodeEmpty = false;
            this.authModel.AuthToken = this.authModel.AuthToken1.toString() + this.authModel.AuthToken2.toString() + this.authModel.AuthToken3.toString() + this.authModel.AuthToken4.toString() + this.authModel.AuthToken5.toString() + this.authModel.AuthToken6.toString()

            this.mfaRequestModel.authCode = this.authModel.AuthToken;
            this.mfaRequestModel.authCodeServer = this.authcodeServer;
            this.mfaRequestModel.codeValidTill = this.codeValidTill;
            this.mfaRequestModel.loginID = this._global.currentUser.userProfileId.toString();
            this.mfaGateWay.verifyAuthenticationCode(this.mfaRequestModel).subscribe(
                (res: any) => {
                    this.loading = true
                    if (res == true) {
                        localStorage.setItem("isMfaValidated", "true");
                            this._currentUserGateway.getCurrentUserByName().subscribe((user) => {
                                if (user != null) {
                                    this._global.currentUser = user
                                    this.userRedirectionCheck();
                                }
                            })
                            this.loading = false
                        }
                        else {
                            this.invalidTokenError = true;
                            this.loading = false
                        }
                    }
                );
        }
        else {
            this.isAuthCodeEmpty = true;
            const authCode1 = this.elementRef.nativeElement.querySelector('#AuthToken1');
            if (authCode1) {
                authCode1.focus();
                this.loading = false
            }
            return;
          
        }
        
    }

    userRedirectionCheck() {
        this._currentUserGateway.isLicenseExpiring(this._global.currentUser).subscribe(
            (data: any) => {
                if (data != null) {
                    const isLicenseExpires = data === true;
                    this.redirectionMechanism(this._global.currentUser, isLicenseExpires);
                }
            })
    }
    private redirectionMechanism(currentUser: CurrentUser, isLicenseExpires: boolean) {
        if (currentUser.isChangePassword) {
            this.router.navigate(['/' + this._global.currentUser.insuranceCompanyShortName.toLowerCase() + '/user-management/update/' + currentUser.userProfileId + '/' + 1 + '/' + Number(currentUser.isChangeEmail) + '/' + Number(currentUser.isChangeCellPhoneNumber)])
        }
        else if (currentUser.isChangeEmail) {
            currentUser.menuVisible = false;
            this.router.navigate(['/' + this._global.currentUser.insuranceCompanyShortName.toLowerCase() + '/user-management/ChangeEmail/' + currentUser.userProfileId + '/' + '/' + Number(currentUser.isChangeCellPhoneNumber)])
        }
        else if (currentUser.isChangeCellPhoneNumber) {
            currentUser.menuVisible = false;
            this.router.navigate(['/' + this._global.currentUser.insuranceCompanyShortName.toLowerCase() + '/user-management/ChangeCellPhoneNo/' + currentUser.userProfileId])
        }
        else if (currentUser.AttestationRequired && currentUser.insuranceCompanyShortName.toLowerCase() == "ssi") {
            currentUser.menuVisible = false;
            this.router.navigate(['/' + this._global.currentUser.insuranceCompanyShortName.toLowerCase() + '/attestation']); //attestation
        }
        else if (isLicenseExpires==true)
        {
            currentUser.menuVisible = false;
            this.router.navigate(['/' + this._global.currentUser.insuranceCompanyShortName.toLowerCase() + '/user-management/licenselogin/' + currentUser.userProfileId])
        }
        else if (currentUser.roleCode.toLowerCase() === "call center agent" && currentUser.insuranceCompanyShortName.toLowerCase() === "ssi") {
            currentUser.menuVisible = true;
            this.router.navigate(['/' + this._global.currentUser.insuranceCompanyShortName.toLowerCase() +'/callStart/consumer-information']);
        }

        else {
            //seting this property for displaying menu when directly loading home page
            currentUser.homeRedirect = "Active";
            currentUser.menuVisible = true;
            this.router.navigate(['/' + this._global.currentUser.insuranceCompanyShortName.toLowerCase() + '/home']);

        }
    }
    
    startTimer() {
        this.interval = setInterval(() => {
            if (this.tokenValidity === 0) {
                //this.tokenValidity--;
            // location.replace('/Login.aspx');
                this.hideTokenValidity = true;

            } else {
                this.tokenValidity--;
            }
            this.validityText = this.transform(this.tokenValidity)
        }, 1000);
    }
    checkUndefinedEmpty(value: any): boolean {
        if (value !== undefined && value !== null && value.toString() !== '') {
            return true;
        } else {
            return false;
        }
    }
    onDigitInput(event) {
        let element;
        if ((isFinite(event.key) && event.key !== ' ') || event.code === 'ArrowRight') {
            element = event.target.nextElementSibling;
        }
        if (event.code === 'Backspace' || event.code === 'ArrowLeft') {
            element = event.target.previousElementSibling;
        }
        if (event.target.value.length > 1) {
            if (event.target.nextElementSibling != null) {
                event.target.nextElementSibling.value = event.target.value.slice(-1);
                this.authModel[event.target.nextElementSibling.id] = event.target.value.slice(-1);
            }
            event.target.value = event.target.value.substring(0, 1);
            this.authModel[event.target.id] = event.target.value.substring(0, 1);
        }
        if (element == null)
            return;
        else
            element.focus();
    }


    resetValues() {
        this.authModel.AuthToken1 = 0;
        this.authModel.AuthToken2 = 0;
        this.authModel.AuthToken3 = 0;
        this.authModel.AuthToken4 = 0;
        this.authModel.AuthToken5 = 0;
        this.authModel.AuthToken6 = 0;
        this.invalidTokenError = false;
        this.isAuthCodeEmpty = false;
        this.hideTokenValidity = false;
        this.showEmailNotSendError = false;
    }

    numberOnly(event): boolean {
        const charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
        return true;

    }

    disableArrowKeys(event) {
        if ((event.key === 'ArrowUp' || event.key === 'ArrowDown') && !event.target.value) {
            event.preventDefault();
        }
    }

    setTokenTime() {
        this.tokenValidity = 300;
    }

    transform(value: number): string {
        const minutes: number = Math.floor(value / 60);
        var minutesText = ' minutes';
        var secondsText = ' seconds'
        if (minutes <= 1) {
            minutesText = ' minute';
        }
        const secondsLeft: number = value - (minutes * 60);
        if (secondsLeft <= 1) {
            secondsText = ' second'
        }
        return minutes + minutesText + ' ' + secondsLeft + secondsText;
    }

    onPaste(event: any): void {
        const clipboardData = event.clipboardData || window.clipboardData;
        const pastedText = clipboardData.getData('text');

        if (pastedText && pastedText.length == 6) {
            this.authModel.AuthToken1 = pastedText[0];
            this.authModel.AuthToken2 = pastedText[1];
            this.authModel.AuthToken3 = pastedText[2];
            this.authModel.AuthToken4 = pastedText[3];
            this.authModel.AuthToken5 = pastedText[4];
            this.authModel.AuthToken6 = pastedText[5];

            const authCode6 = this.elementRef.nativeElement.querySelector('#AuthToken6');
            if (authCode6) {
                authCode6.focus();
            }
        }
    }

}
